"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function navigatorLanguages() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === undefined) return null;
  var detected = [];

  if (navigator.languages) {
    detected = [].concat(_toConsumableArray(navigator.languages));
  }

  if (navigator.language) {
    detected.push(navigator.language);
  }

  if (navigator.browserLanguage) {
    detected.push(navigator.browserLanguage);
  }

  if (navigator.userLanguage) {
    detected.push(navigator.userLanguage);
  }

  return detected.length > 0 ? detected : null;
}

exports["default"] = navigatorLanguages;